import request from "@/utils/request";
import Qs from "qs";
export function login(data) {
  return request({
    url: "/login/login",
    method: "post",
    data: Qs.stringify(data),
  });
}

export function logout(data) {
  return request({
    url: "/login/logout",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取后台用户的权限
export function getRoleMenu(data) {
  return request({
    url: "/admin_user/get_menu_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取后台用户个人信息
export function getInfo(data) {
  return request({
    url: "/common/get_user_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 后台用户密码修改
export function editPassword(data) {
  return request({
    url: "/admin_user/edit_password",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取项目域名
export function getDomain(data) {
  return request({
    url: "/common/get_domain",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取登录验证码
export function getCaptcha() {
  return request({
    url: "/login/captcha",
    method: "get",
    responseType: "arraybuffer",
  });
}

// 修改自己密码
export function editMyPass(data) {
  return request({
    url: "/common/my_edit_password",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 指令集静默登录
export function loginZlj(data) {
  return request({
    url: "/login/login_zlj",
    method: "post",
    data: Qs.stringify(data),
  });
}
